import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IPagedResult } from 'src/app/shared/models/pagedResult';
import { BaseService } from './base.service';
import { ApiVersions } from './api-version';
import { ProfileHistory } from '../models/profileHistory';

@Injectable()
export class HistoryService extends BaseService {
  private basePath = 'history';

  constructor() {
    super();
  }

  profileHistory(
    pageIndex: number,
    pageSize: number,
    personId: string
  ): Observable<IPagedResult<ProfileHistory>> {
    return this.get<IPagedResult<ProfileHistory>>(
      this.basePath,
      {
        params: {
          pageIndex: String(pageIndex),
          pageSize: String(pageSize),
          personId: personId.trim(),
        },
      },
      ApiVersions.v1_0
    );
  }

  profileFieldHistory(
    pageIndex: number,
    pageSize: number,
    personId: string,
    attributeName: string
  ): Observable<IPagedResult<ProfileHistory>> {
    return this.get<IPagedResult<ProfileHistory>>(
      this.basePath + `/${pageIndex}/${pageSize}/${attributeName}/${personId}`,
      null,
      ApiVersions.v1_0
    );
  }
}
